module.exports = __webpack_public_path__ + "img/system44.cd0d706c.png";